import { useAtom } from "jotai";
import { useCallback } from "react";

import { pagesAtom } from "../../fkc.state";
import { Pages } from "../../fkc.types";
import { Fallback } from "../shared/fallback/fallback.component";

export function PlaidRetryPage(): JSX.Element {
  const [, setPage] = useAtom(pagesAtom);

  const goToPlaid = useCallback(() => {
    setPage(Pages.PLAID);
  }, [setPage]);

  return (
    <Fallback
      title="Something went wrong connecting your account. Try again?"
      onTryAgain={goToPlaid}
    />
  );
}
